export default {
    GROSS_PRODUCT(state, items) {
        state.items = items
    }
}
